import React from 'react';

import { Typography } from 'antd';

import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import type IProduct from 'interfaces/IProduct';
import { CHECKOUT_SUN_URL } from 'settings';

interface IProps {
  currentProduct: IProduct;
  currentUserId: number;
  physicalProductPending: boolean;
}

const CheckoutSunLink = ({ currentProduct, currentUserId, physicalProductPending }: IProps) => {
  const isAffiliated = currentProduct.producer_id !== currentUserId;
  let urlCheckoutSun = `${CHECKOUT_SUN_URL}/${currentProduct.hash ?? currentProduct.id}`;

  if (isAffiliated) {
    urlCheckoutSun += `?a=${currentUserId}`;
  }

  return (
    <div className='flex flex-col'>
      <div className='flex justify-start'>
        <Typography.Text className='mb-2 text-[1.25rem] text-black'>Checkout Sun</Typography.Text>
      </div>

      <div className='flex max-w-76 items-center max-sm:max-w-none'>
        {!physicalProductPending && <CustomCopyToClipboard fullWidth disableUnderline text={urlCheckoutSun} />}
      </div>
    </div>
  );
};

export default CheckoutSunLink;
